<div class="container-fluid d-flex justify-content-center align-items-center min-vh-100">
  <mat-card class="login-card">
    <div class="row">
      <!-- Logo -->
      <div class="col-6">
        <img src="/assets/img/LOGOTIPO.png" alt="Icono" class="logo">
      </div>

      <!-- Formulario -->
      <div class="col-6">
        <div class="formulario text-center">
          <span class="subtitle">Entrar a Encuesta</span>
          <form autocomplete="off" (ngSubmit)="sendForm()" [formGroup]="form">
            <!-- Campo Token de Encuesta -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Token de encuesta</mat-label>
              <input matInput type="text" formControlName="token">
              <mat-icon matSuffix color="primary">vpn_key</mat-icon>
            </mat-form-field>

            <!-- Botones -->
            <button mat-flat-button color="primary" class="btn-submit" type="submit">
              Entrar
            </button>

          </form>
        </div>
      </div>
    </div>
  </mat-card>
</div>